import { ethers, utils } from "ethers";
import { defineStore } from "pinia";

import abiJson from "./bc/abi.json";
import chainsJson from "./bc/chains.json";

export const defaultChainId = process.env.VUE_APP_CHAIN_ID_AVAX;

import { createWeb3Modal, defaultConfig } from '@web3modal/ethers5/vue'

	const avax = {
		chainId: 43114,
		name: 'AVAX',
		currency: 'AVAX',
		explorerUrl: 'https://snowtrace.io',
		rpcUrl: 'https://api.avax.network/ext/bc/C/rpc'
	}

	const metadata = {
		name: 'DashLeague',
		description: 'MMO blockchain game',
		url: 'https://game.dashleague.io/', // origin must match your domain & subdomain
		icons: ['https://game.dashleague.io/favicon.png']
	}

	const ethersConfig = defaultConfig({
		/*Required*/
		metadata,

		/*Optional*/
		enableEIP6963: true, // true by default
		enableInjected: true, // true by default
		enableCoinbase: true, // true by default
		rpcUrl: 'https://api.avax.network/ext/bc/C/rpc', // used for the Coinbase SDK
		defaultChainId: 43114 // used for the Coinbase SDK
	})

	createWeb3Modal({
		ethersConfig,
		chains: [avax],
		projectId: 'b94b3de90b600ef1351c5e54ed96844f',
		enableAnalytics: false // Optional - defaults to your Cloud configuration
	})

export const bcStore = defineStore("bc", {
	id: "bc",
	state: () => ({
		//dataUpdateInterval: 60 * 1000, // 30 seconds
		web3Modal: null,		
		signer: null,	
        signerAddress: null,	
        signerChainId: null,	
		rpcProvider: null,
		currentChainId: null, // default chain
        
        chainChanged: 0,
        signerChanged: 0,
        updateInterval: 30000, // 30 sec,

        chains: chainsJson,
        abi: abiJson,
        chainETH: null,
        chainAVAX: null,
        chainsMics: {
            43114: {
                name: "AVAX",
                symbol: "AVAX",
                explorerUrl: "https://snowtrace.io/", 
                primary: true, 
            },
            1: {
                name: "ETH",
                symbol: "ETH",
                explorerUrl: "https://rinkeby.etherscan.io/", 
                primary: false 
            },
            31335: {
                name: "AVAX",
                symbol: "AVAX",
                explorerUrl: "https://rinkeby.etherscan.io/", 
                primary: true, 
            },
            31336: {
                name: "ETH",
                symbol: "ETH",
                explorerUrl: "https://rinkeby.etherscan.io/", 
                primary: false 
            },
            31337: {
                name: "AVAX", //Node VPS 1 (31337)
                symbol: "AVAX",
                explorerUrl: "https://rinkeby.etherscan.io/",  
                primary: true, 
            },
            31338: {
                name: "ETH", //Node VPS 2 (31338)
                symbol: "ETH",
                explorerUrl: "https://rinkeby.etherscan.io/", 
                primary: false  
            },
            43113: {
                name: "AVAX", //Node VPS 1 (31337)
                symbol: "AVAX",
                explorerUrl: "https://testnet.snowtrace.io/",  
                primary: true, 
            },
            5: {
                name: "ETH", //Node VPS 2 (31338)
                symbol: "ETH",
                explorerUrl: "https://goerli.etherscan.io/", 
                primary: false  
            }
        },
        admins: [
            '0x242B39E000A1F6B509DAe48965D27eb93464F970',
            '0x15B9e4DEBf6EA46692f00A580f43A09573b1eD4e'
        ]
	}),

	getters: {
        web3(state) {
			return state.web3Modal;
		},		
		account(state) {
			return state.signer;
		},
        accountAddress(state) {
			return state.signerAddress;
		},
        chainId(state) {
			return state.currentChainId;
		},
		chain(state) {
            let chain = null
            if (state.chains && state.currentChainId) {
                chain = {
                    ...state.chains[state.currentChainId],
                    ...state.chainsMics[state.currentChainId]
                }                
            }
			return chain
		},
        chainValid(state) {            
            if (state.signerChainId) {
                if (state.chains && state.chains[state.signerChainId]) {
                    return true
                }
                return false
            } 
			return 0;
		},
        rpc(state) {
			return state.rpcProvider;
		},
        contract(state){ return function(name, chain) {
            let rpc = this.rpc
            if (!chain) {
                chain = this.chain
            } else {
                rpc = chain.rpc
            }
            if (chain && state.abi && state.abi[name]) {
                return {
                    instance: new ethers.Contract(chain.contracts[name], state.abi[name], rpc),
                    address: chain.contracts[name]
                }               
            }   
            return null
        }},
        isAdmin(state){ 
            if (this.accountAddress) {
                return state.admins.find(a => a === this.accountAddress) > -1 ? true : false
            }    
            return false
        },
        //updated(state) {
        //    return { chain: state.chainChanged, account: state.signerChanged }
        //},
        //defaultChainId(state) {
		//	return config.chains[state.chainId];
		//},
	},

    actions: {
        setWeb3(web3) {
            console.log(`setWeb3`, web3);
            this.web3Modal = web3
        },

        getChain(chainId) {            
            console.log(`setRpc...`, this.chainValid, this.currentChainId);  
            //const abi = await (await fetch('https://dlc.appdev.pp.ua/bc/abi.json')).json()
            //const chains = await (await fetch('https://dlc.appdev.pp.ua/bc/chains.json')).json()

            return {
                ...this.chains[chainId],
                ...this.chainsMics[chainId],
                abi,
                rpc: new ethers.providers.JsonRpcProvider(this.chains[chainId].rpc, "any")
            }
        },
    
        async setRpc() {            
            console.log(`setRpc...`, this.chainValid, this.currentChainId);  
            //this.abi = await (await fetch('https://dashleague.io/bc/abi.json')).json()
            //this.chains = await (await fetch('https://dashleague.io/bc/chains.json')).json()
            
            const oldChainId = this.currentChainId          
            if (this.chainValid === true) {
                this.currentChainId = this.signerChainId;
            } else {
                this.currentChainId = defaultChainId;
            }
            if (oldChainId != this.currentChainId) { 
                this.rpcProvider = new ethers.providers.JsonRpcProvider(this.chains[this.currentChainId].rpc, "any");

                this.chainAVAX = {
                    ...this.chains[process.env.VUE_APP_CHAIN_ID_AVAX],
                    ...this.chainsMics[process.env.VUE_APP_CHAIN_ID_AVAX],
                    rpc: new ethers.providers.JsonRpcProvider(this.chains[process.env.VUE_APP_CHAIN_ID_AVAX].rpc, "any")
                }
                this.chainETH = {
                    ...this.chains[process.env.VUE_APP_CHAIN_ID_ETH],
                    ...this.chainsMics[process.env.VUE_APP_CHAIN_ID_ETH],
                    rpc: new ethers.providers.JsonRpcProvider(this.chains[process.env.VUE_APP_CHAIN_ID_ETH].rpc, "any")
                }
            }
        },
    
        async connect() {
            console.log(`connect`);
            const providerWeb3 = await this.web3Modal.connect();          
            this.signer = new ethers.providers.Web3Provider(providerWeb3, "any")
            const network = await this.signer.getNetwork()
            this.signerChainId = network.chainId
            const accounts = await this.signer.listAccounts()
            if (accounts.length > 0) {
                // this.signerAddress = '0x672354B7BcF381EA4cfeaA349d053274737Ba33a'
                this.signerAddress = accounts[0]
                this.setRpc()
            } else {
                this.disconnect()
            }
            
            providerWeb3.on("connect", async (info) => {
                console.log(`providerWeb3.on connect`, this.signerChainId, parseInt(info.chainId));                
                this.signerChainId = parseInt(info.chainId)
                this.setRpc()               
            });
    
            providerWeb3.on("accountsChanged", async (accounts) => { 
                console.log(`providerWeb3.on accountsChanged`, accounts);       
                if (accounts.length > 0) {
                    //this.signerAddress = '0x672354B7BcF381EA4cfeaA349d053274737Ba33a'
                    this.signerAddress = accounts[0]
                } else {
                    this.disconnect()
                }       
            });
    
            providerWeb3.on("chainChanged", async (chainId) => {
                console.log(`providerWeb3.on chainChanged`, this.signerChainId, parseInt(chainId));
                this.signerChainId = parseInt(chainId)                
                this.setRpc()                
            });
    
            providerWeb3.on("network", (newNetwork, oldNetwork) => {
                // https://github.com/ethers-io/ethers.js/issues/866
                // When a Provider makes its initial connection, it emits a "network"
                // event with a null oldNetwork along with the newNetwork. So, if the
                // oldNetwork exists, it represents a changing network
                if (oldNetwork) {
                    console.log(`providerWeb3.on network`, newNetwork);
                    window.location.reload();
                }
            });
        },
    
        async disconnect() { 
            console.log(`disconnect`);
            this.currentChainId = defaultChainId
            this.signer = null
            this.signerChainId = null
            this.signerAddress = null
                        
            try {
              await this.web3Modal.clearCachedProvider();
              localStorage.clear(); 
            } catch (error) {
              console.error(error)
            }
            this.setRpc()            
        },
    },
});
